import util from "./_util";

const { request } = util;

export default {
  /**
   * 租户管理
   * */
  // 添加
  systenantAdd(data) {
    return request.post("/SysTenant/SaveTenant", data);
  },

  // 删除
  systenantDel(params) {
    return request.post(`/SysTenant/DeleteTenant/${params}`);
  },

  // 修改
  systenantUpdate(params) {
    return request.post("/SysTenant/SaveTenant", params);
  },
  // 删除异常
  syserrorDel(params) {
    return request.post("/SysExceptionLog/Delete", params);
  },
  // 修改异常状态为已处理
  syserrorHandle(params) {
    return request.post("/SysExceptionLog/Handle", params);
  },
  // 保存某个租户选中的模块
  securityAdd(params) {
    return request.post("/SysSecurity/UpdateTenantModules", params);
  },
};
